import script from "./ProgressV2.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgressV2.vue?vue&type=script&setup=true&lang=js"

import "./ProgressV2.vue?vue&type=style&index=0&id=6e4265eb&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e4265eb"]])

export default __exports__